import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Landing from "components/Landing";
import { NotFound } from "components/Layout";

import AdCampaigsRoutes from "contexts/adCampaigns";
import LawyerRoutes from "contexts/lawyers";
import ConsultationRoutes from "contexts/consultations";
import CommunityRoutes from "contexts/community";
import RfeRoutes from "contexts/rfe";
import NewsRoutes from "contexts/news";
import ChatRoutes from "contexts/chats";

import PrivateRoute from "./PrivateRoute";

export default class Routes extends React.Component {
  public render() {
    return (
      <Switch>
        <Route path="/landing" component={Landing} />
        <PrivateRoute path="/consultations" component={ConsultationRoutes} />
        <PrivateRoute path="/lawyers" component={LawyerRoutes} />
        <PrivateRoute path="/ad-campaigns" component={AdCampaigsRoutes} />
        <PrivateRoute path="/community" component={CommunityRoutes} />
        <PrivateRoute path="/rfe" component={RfeRoutes} />
        <PrivateRoute path="/news" component={NewsRoutes} />
        <PrivateRoute path="/chats" component={ChatRoutes} />
        <Route exact path="/" component={this.redirectFromRoot} />
        <Route component={NotFound} />
      </Switch>
    );
  }

  private redirectFromRoot = () => <Redirect to="/consultations" />;
}
